import { Direction, PaletteMode, ThemeOptions } from '@mui/material';
import createPalette from '@mui/material/styles/createPalette';
import mediaQuery from 'css-mediaquery';
import RabexTypography from './Typography';
import RabexButton from './Button';
import RabexLightPalette from './Palette/light';
import RabexDarkPalette from './Palette/dark';
import RabexTabs from './Tabs';
import RabexTab from './Tab';
import ReduxChip from './Chip';
import RabexPaper from './Paper';
import RabexDivider from './Divider';
import RabexTooltip from './Tooltip';
import RabexAvatar from './Avatar';
import RabexBreadcrumbs from './Breadcrumbs';
import RabexListItemAvatar from './ListItemAvatar';
import RabexToggleButton from './ToggleButton';
import RabexToggleButtonGroup from './ToggleButtonGroup';
import RabexIconButton from './IconButton';
import RabexInput from './Input';
import RabexSelect from './Select';
import RabexList from './List';
import RabexMenuItem from './MenuItem';
import RabexTableContainer from './TableContainer';
import RabexTableHead from './TableHead';
import RabexTableCell from './TableCell';
import RabexSlider from './Slider';
import RabexInputAdornment from './InputAdornment';
import RabexShadows from './Shadows';
import RabexAccordion from './Accordion';
import RabexCheckbox from './Checkbox';
import RabexBackdrop from './Backdrop';
import RabexAlert from './Alert';
import RabexAlertTitle from './AlertTitle';
import RabexModal from './Modal';
import RabexFormControlLabel from './FormControlLabel';
import RabexRadio from './Radio';
import RabexTextField from './TextField';
import RabexContainer from './Container';
import RabexPagination from './Pagination';
import RabexPaginationItem from './PaginationItem';
import RabexGrid from './Grid';

export type themeTypes = {
  mode?: PaletteMode;
  direction?: Direction;
  deviceType?: 'mobile' | 'desktop';
};

const getDesignTokens = ({
  deviceType,
  mode = 'dark',
  direction = 'rtl'
}: themeTypes): ThemeOptions => ({
  direction,
  spacing: 4,
  shadows: RabexShadows,
  components: {
    ...(!!deviceType && {
      MuiUseMediaQuery: {
        defaultProps: {
          ssrMatchMedia: query => ({
            matches: mediaQuery.match(query, {
              // The estimated CSS width of the browser.
              width: deviceType === 'mobile' ? '0px' : '1200px'
            })
          })
        }
      }
    }),
    MuiButton: RabexButton.components,
    MuiTypography: RabexTypography.components,
    // MuiTabs: RabexTabs.components,
    // MuiTab: RabexTab.components,
    MuiChip: ReduxChip.components,
    MuiPaper: RabexPaper.components,
    MuiDivider: RabexDivider.components,
    MuiTooltip: RabexTooltip.components,
    MuiAvatar: RabexAvatar.components,
    MuiBreadcrumbs: RabexBreadcrumbs.components,
    MuiListItemAvatar: RabexListItemAvatar.components,
    MuiToggleButton: RabexToggleButton.components,
    MuiToggleButtonGroup: RabexToggleButtonGroup.components,
    MuiIconButton: RabexIconButton.components,
    MuiInput: RabexInput.components,
    MuiSelect: RabexSelect.components,
    MuiList: RabexList.components,
    MuiMenuItem: RabexMenuItem.components,
    MuiTableHead: RabexTableHead.components,
    MuiTableCell: RabexTableCell.components,
    MuiTableContainer: RabexTableContainer.components,
    MuiSlider: RabexSlider.components,
    MuiInputAdornment: RabexInputAdornment.components,
    MuiAccordion: RabexAccordion.components,
    MuiCheckbox: RabexCheckbox.components,
    MuiBackdrop: RabexBackdrop.components,
    MuiAlert: RabexAlert.components,
    MuiAlertTitle: RabexAlertTitle.components,
    MuiModal: RabexModal.components,
    MuiFormControlLabel: RabexFormControlLabel.components,
    MuiRadio: RabexRadio.components,
    MuiTextField: RabexTextField.components,
    MuiContainer: RabexContainer.components,
    MuiPagination: RabexPagination.components,
    MuiPaginationItem: RabexPaginationItem.components,
    MuiGrid: RabexGrid.components
  },
  palette: {
    ...(mode === 'light'
      ? createPalette(RabexLightPalette)
      : createPalette(RabexDarkPalette))
  },
  typography: RabexTypography.typography
});

export default getDesignTokens;
